import { subscribeLogRocketPageViews } from '@globals/logRocketPageViews'
import { useEffect, useState } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router'
import appRoutes from './appRoutes'

const RouteRenderer = () => {
  // Created once per mount: a new router on every render would reset routing
  // state and re-subscribe its listeners each time the parent re-renders.
  const [appBrowserRouter] = useState(() => createBrowserRouter(appRoutes))

  useEffect(() => subscribeLogRocketPageViews(appBrowserRouter), [appBrowserRouter])

  return <RouterProvider router={appBrowserRouter} />
}

export default RouteRenderer
